import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class TagService {
  constructor(private http: HttpClient,
    private appGlobals: AppGlobals) { }

  getProductTags(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}product-tags`, { params: filters });
  }

  getProductTagList(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}product-tags-list`, { params: filters });
  }

  getTallyPurchaseLedger(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-purchase-ledger-list`, { params: filters });
  }

  getTallyCreditablePayable(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-creditable-payable-ledger-list`, { params: filters });
  }

  getTallyTaxation(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-taxation-ledger-list`, { params: filters });
  }

  getTallyTDS(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-tds-ledger-list`, { params: filters });
  }

  getTallyTCS(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-tcs-ledger-list`, { params: filters });
  }

  getTallyPaidDiscount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-paid-discount-ledger-list`, { params: filters });
  }

  getTallyReceivedDiscount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-received-discount-ledger-list`, { params: filters });
  }

  getTallyRoundOffAdd(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-round-off-add-ledger-list`, { params: filters });
  }

  getTallyRoundOffLess(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-round-off-less-ledger-list`, { params: filters });
  }

  getTallyOtherCharges(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-other-charges-ledger-list`, { params: filters });
  }

  getTallyPurchaseVoucherConfig(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-purchase-voucher-config-ledger-list`, { params: filters });
  }

  getTallyExpenseVoucherConfig(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-expense-voucher-config-ledger-list`, { params: filters });
  }

  getTallyPurchaseExpenseVoucherConfig(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-purchase-expense-voucher-config-ledger-list`, { params: filters });
  }

  getTallyPurchaseReturnVoucherConfig(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-purchase-return-voucher-config-ledger-list`, { params: filters });
  }

  getTallyAllVoucherTypes(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-voucher-types-list`, { params: filters });
  }

  getTallySupplierGroups(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-supplier-groups-list`, { params: filters });
  }

  getTallyItemGroups(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-item-groups-list`, { params: filters });
  }

  getTallyLedgerGroups(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-ledger-groups-list`, { params: filters });
  }

  getTallyCostCenter(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-cost-center-ledger-list`, { params: filters });
  }

  getTallyGodown(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-godown-ledger-list`, { params: filters });
  }

  getTallyRawMaterialItem(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-raw-material-item-ledger-list`, { params: filters });
  }

  getTallyExpenseItem(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-expense-item-ledger-list`, { params: filters });
  }

  getTallyUnitItem(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-unit-item-ledger-list`, { params: filters });
  }

  getTallyUnitQtyCodesItem(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-unit-qty-code-list`, { params: filters });
  }

  getTallyProductPercentage(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-product-percentage-ledger-list`, { params: filters });
  }

  getTallyTagPercentage(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-tag-percentage-ledger-list`, { params: filters });
  }

  getTallySubCategory(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-sub-category-percentage-ledger-list`, { params: filters });
  }

  getTallyExpense(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}stored-tally-expense-ledger-list`, { params: filters });
  }

  getLedgerMappings(companyId: string, mappingType: string): Observable<any> {
    return this.http.get<any>(
      `${this.appGlobals.apiUrl.tally}tally-${mappingType.toLowerCase()}-ledger-mappings`,
      {
        params: { companyId },
      }
    );
  }

  getSystemPurchaseLedger(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}products-for-tally`, { params: filters });
  }

  getSystemUnits(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}units-for-tally`, { params: filters });
  }

  getSystemCreditablePayable(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}suppliers-for-tally`, { params: filters });
  }

  getSystemTaxation(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}tax-list-for-tally`, { params: filters });
  }

  getSystemTDS(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}tds-natures`, { params: filters });
  }

  getSystemTCS(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}tcs-natures`, { params: filters });
  }

  getSystemPaidDiscount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}paid-discount-natures`, { params: filters });
  }

  getSystemReceivedDiscount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}received-discount-natures`, { params: filters });
  }

  getSystemRoundOffAdd(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}round-off-add-natures`, { params: filters });
  }

  getSystemRoundOffLess(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}round-off-less-natures`, { params: filters });
  }

  getSystemOtherCharges(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}other-charges-list`, { params: filters });
  }

  getSystemProductPercentage(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}`, { params: filters });
  }

  getSystemTagPercentage(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}`, { params: filters });
  }

  getSystemSubCategory(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}`, { params: filters });
  }

  getSystemExpense(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}product-expense-for-tally`, { params: filters });
  }

  mapLedgerToTallyTag(mappingPayload: { systemTag: any, tallyTag: any, companyId: string, isSync: boolean, unitCode: string, voucherType: string, supplierGroup: string, itemGroup: string }): Observable<any> {
    return this.http.post(`${this.appGlobals.apiUrl.tally}tally-ledger-mapping`, mappingPayload);
  }

  deleteLedgerMapping(mappingPayload: { systemTag: any, tallyTag: any, companyId: string, voucherType: string }): Observable<any> {
    return this.http.post(`${this.appGlobals.apiUrl.tally}tally-ledger-unmap`, mappingPayload);
  }

  autoMap(company: string, mappingType: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}auto-map-ledgers`, { params: { company, mappingType } });
  }

  resetTallyConfig(company: string, mappingType: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}reset-tally-config`, { params: { company, mappingType } });
  }

  resetAllTallyConfig(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}reset-all-tally-config`, { params: { company } });
  }

  closeTallyEXE(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}close-tally-exe`, { params: { company } });
  }

  restartTallyEXE(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}restart-tally-exe`, { params: { company } });
  }

  undoConfig(company: string, mappingType: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}undo-auto-map-same-as-description`, { params: { company, mappingType } });
  }

  tagSameAsDescription(company: string, mappingType: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}auto-map-same-as-description`, { params: { company, mappingType } });
  }

  tagAllSameAsDescription(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}auto-map-all-same-as-description`, { params: { company } });
  }

  syncTallyLedgers(company: string, mappingType: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}sync-tally-ledgers`, { params: { company, mappingType } });
  }

  syncAllTallyLedgers(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}sync-all-tally-ledgers`, { params: { company } });
  }

  autoMapAllTallyLedgers(company: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}auto-map-all-tally-ledgers`, { params: { company } });
  }

  getTags(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}tags`, { params: filters });
  }

  updateProductTag(body: any): Observable<any> {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}update-product-tag`, body);
  }

  exportProductTagData(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}export-product-tags`, { params: filters });
  }

  importProductTagData(body: any, filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}import-product-tags`, body, { params: filters });
  }

  importPetpoojaTag(body: any, filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}import-petpooja-tags`, body, { params: filters });
  }

  getPetpoojaTags(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}petpooja-tags`, { params: filters });
  }

  getSupplierTags(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}supplier-tags`, { params: filters });
  }

  addSupplierTags(body: any): Observable<any> {
    return this.http.post<any>(`${this.appGlobals.bypassApiUrl.invoice}supplier-tags`, body);
  }

  updateSupplierTags(body: any): Observable<any> {
    return this.http.post<any>(`${this.appGlobals.bypassApiUrl.invoice}update-supplier-tags`, body);
  }

  exportSupplierTags(filters: HttpParams | { [params: string]: string | string[] | boolean } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}export-supplier-tags`, { params: filters });
  }

  autoTag(company?: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}auto-tag`, { params: company ? { company } : {} });
  }

  autoTagEnabled(company?: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}auto-tag-enabled`, { params: company ? { company } : {} });
  }

  autoConversionEnabled(company?: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}auto-conversion-enabled`, { params: company ? { company } : {} });
  }

  autoMapStatus(company?: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.tally}auto-map-status`, { params: company ? { company } : {} });
  }

  getTagactivityLogs(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}tag-activity-log`, { params: filters });
  }

  getCompanyDetails(company = null) {
    if (company) {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details?company=${company}`);
    } else {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details`);
    }
  }

  exportRawMaterials(company = null) {
    if (company) {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}export-raw-materials?company=${company}`);
    } else {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}export-raw-materials`);
    }
  }

  getRetailPosRawMaterials(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}get-retail-pos-raw-materials`, { params: filters });
  }

  getRetailPosSuppliers(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}get-retail-pos-supplier`, { params: filters });
  }


  getCompanyInfo(company: string) {
    return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details?company=${company}`);
  }

  getTallyConfig(company: string) {
    return this.http.get(`${this.appGlobals.apiUrl.tally}tally-configuration?company=${company}`);
  }

  getTallyConfigReport(company: string) {
    return this.http.get(`${this.appGlobals.apiUrl.tally}tally-configuration-report?company=${company}`);
  }

  getPetpoojaSupplierList(company = null) {
    if (company) {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}petpooja-suppliers?company=${company}`);
    } else {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}petpooja-suppliers`);
    }
  }

  getRetailPosProductTags(company = null) {
    if (company) {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}retail-pos-product-tags?company=${company}`);
    } else {
      return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}retail-pos-product-tags`);
    }
  }
  /**
   * update petpooja conversion tags
   * @param body 
   * @returns 
   */
  updatePetpoojaConversionData(body: any): Observable<any> {
    return this.http.post<any>(`${this.appGlobals.apiUrl.pushtopetpooja}update-petpooja-unit-conversion`, body);
  }

  /**
   * get conversion tags list
   * @param filters 
   * @returns 
   */
  getConversionTags(queryParams): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.pushtopetpooja}conversion-tags-list`, { params: queryParams });
  }

  /**
   * import petpooja unit conversion
   * @param body 
   * @returns 
   */
  importPetpoojaUnitConversion(body: any, params: { [key: string]: string } = {}): Observable<any> {
    return this.http.post<any>(`${this.appGlobals.apiUrl.pushtopetpooja}import-petpooja-unit-conversion`, body, { params });
    //return this.http.post<any>(`http://localhost:3009/api/web/push-to-petpooja/v1/import-petpooja-unit-conversion`, body, { params });
  }


  updateProductAutoTag(body: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}update-auto-tag`, body);
  }

  saveAutoTags(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}save-auto-tag`, { params: filters });
  }

  syncPetpoojaTagsToDashboardAndTally(body: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}sync-tags`, body);
  }

  getTagsV2(filters: HttpParams | { [params: string]: string | string[] | number | boolean } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoiceV2}tag-list`, { params: filters });
  }

  tagNamesV2(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoiceV2}tag-names`, { params: filters });
  }

  updateTagV2(body: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoiceV2}update-tag`, body);
  }

  saveAutoTagsV2(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoiceV2}save-auto-tag`, { params: filters });
  }

  exportTagsV2(filters: HttpParams | { [params: string]: string | string[] | boolean } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoiceV2}export-tags`, { params: filters });
  }

  importTagsV2(body: any, filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoiceV2}import-tags`, body, { params: filters });
  }

  importPetpoojaTagV2(body: any, filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoiceV2}import-petpooja-tags`, body, { params: filters });
  }

  getSupplierTagsV2(filters: HttpParams | { [params: string]: string | string[] | number | boolean } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoiceV2}supplier-tag-list`, { params: filters });
  }

  updateSupplierTagsV2(body: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoiceV2}update-supplier-tags`, body);
  }

  syncRawMaterials(body: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.pushtopetpooja}raw-materials`, body);
  }
}